<!--  -->
<template>
    <div class='card_wrapper box box_v'>
        <div class="title">学习互动</div>
        <div class="tr" :style="'height:'+height">
            <div id="scroll_wrapper_right4" :style="'height:'+contentheight">
                <div class="list_item box box_f1" v-for="(item,index) in list" :key="item.id" :class="{'active':index==selectIndex}">
                    <div class=" box_f1"><div class="slh" style="width:210px">{{item.title}}</div></div>
                    <div class="item_number">{{item.previewNumber}}人次</div>
                    <div class="item_text" style="width:125px">{{item.noticeTime.substring(0,16)}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            height:'100%',
            contentheight:'100%',
            selectIndex:0,
            list:[],
            timer:null
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getData(){
             this.$get(this.urlobj.xf_study,{
                 pageSize:10
             }).then(res=>{
               this.list = res.rows
               this.handelScroll()
            })
        },
        handelScroll(){
            this.height = document.getElementById('right3').offsetHeight - 67 + 'px'
                
            let scrollWrapper = document.getElementById('scroll_wrapper_right4')
            let num = 1
            let contentheight = this.list.length * 53
            this.contentheight = contentheight + 'px'
            if(document.getElementById('scroll_wrapper_right4').offsetHeight<contentheight){
                //没有显示完整
                this.timer = setInterval(()=>{
                    if(num*53<contentheight){
                        this.selectIndex = this.selectIndex+1
                        scrollWrapper.style.marginTop ='-'+num*53+'px' 
                        num++
                    }else{
                        this.selectIndex = 0
                        num = 1
                        scrollWrapper.style.marginTop ='0px' 
                    }
                },3000)
            }
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getData()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {
         clearInterval(this.timer)
    }, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.card_wrapper{
    width: 100%;
    height:100%;
    background-image: url('../../../assets/images/monitorctxf/rightbottom.png');
    background-size: 100% 100%;
    //overflow-y: scroll;
    .title{
        margin:20px 0 20px 20px;
        color:#fff;
        font-size: 18px;
        font-weight: bold
    }
     .tr{
        width:100%;
        padding: 0 10px 10px 10px;
        //flex-wrap:wrap;
        overflow: hidden;
        #scroll_wrapper_right4{
            //transition-timing-function: linear;
            //display: flex;
            //flex-wrap: wrap;
            width: 100%
        }
    }
    .list_item{
        margin: 0 0px 10px 0px;
        padding: 10px 0;
        border-top:1px dashed #fff100;
        border-bottom: 1px dashed #fff100;
        align-items: center;
        color:#fff;
        font-size: 14px;
        
        .item_number{
            color:#fff000;
            padding-right:10px;
            border-right:1px solid #FFD4B2;
            height: 20px;
        }
       
        .item_text{
            margin-left:10px;
            color: #FFD4B2;
        }
    
    }
    .active{
         box-shadow:0 0 20px #ff0000 inset; 
        // border:none;
        // color:#34FFB5;
    }
        
}
</style>